import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Homescreen from "../Homescreen/Homescreen";
import Info from "../Components/Info";
import Clients from "../Components/Clients";
import AddClient from "../Components/AddClient";
import Accounting from "../Components/Accounting";
import Events from "../Components/Events";

function PrivateRoutes() {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <Routes>
      <Route path="/" element={<Homescreen />} />
      <Route path="/home" element={<Homescreen />}>
        <Route path="/home/info" element={<Info />} />
        <Route path="/home/accounting" element={<Accounting />} />
        <Route path="/home/events" element={<Events />} />
        <Route path="/home/clients" element={<Clients />} />
        <Route path="/home/addclient" element={<AddClient />} />
      </Route>
    </Routes>
  );
}

export default PrivateRoutes;
